var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row",
        staticStyle: { "margin-top": "100px", "margin-bottom": "100px" }
      },
      [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-6 pl-md-5" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.sendEmail.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "name" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.business.contact_name")) + "*"
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactData.name,
                            expression: "contactData.name"
                          }
                        ],
                        ref: "name",
                        staticClass: "form-control input-jumbo",
                        attrs: { type: "text", id: "name", required: "" },
                        domProps: { value: _vm.contactData.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactData,
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "company_name" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.business.contact_company_name")
                          ) + "*"
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactData.company_name,
                            expression: "contactData.company_name"
                          }
                        ],
                        ref: "company_name",
                        staticClass: "form-control input-jumbo",
                        attrs: {
                          type: "text",
                          id: "company_name",
                          required: ""
                        },
                        domProps: { value: _vm.contactData.company_name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactData,
                              "company_name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "email" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.business.contact_email")) + "*"
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactData.email,
                            expression: "contactData.email"
                          }
                        ],
                        ref: "email",
                        staticClass: "form-control input-jumbo",
                        attrs: { type: "email", id: "email", required: "" },
                        domProps: { value: _vm.contactData.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactData,
                              "email",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "tel" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.business.contact_tel")) + "*"
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactData.tel,
                            expression: "contactData.tel"
                          }
                        ],
                        ref: "tel",
                        staticClass: "form-control input-jumbo",
                        attrs: { type: "tel", id: "tel", required: "" },
                        domProps: { value: _vm.contactData.tel },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactData,
                              "tel",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button button-large button-block -cyan",
                      attrs: { type: "submit" }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t(_vm.isSending)) + "\n            "
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _vm._m(7),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row",
        staticStyle: { "margin-top": "100px", "margin-bottom": "100px" }
      },
      [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-6 pl-md-5" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.sendEmail.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "name1" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.business.contact_name")) + "*"
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactData.name,
                            expression: "contactData.name"
                          }
                        ],
                        ref: "name",
                        staticClass: "form-control input-jumbo",
                        attrs: { type: "text", id: "name1", required: "" },
                        domProps: { value: _vm.contactData.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactData,
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "company_name1" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.business.contact_company_name")
                          ) + "*"
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactData.company_name,
                            expression: "contactData.company_name"
                          }
                        ],
                        ref: "company_name",
                        staticClass: "form-control input-jumbo",
                        attrs: {
                          type: "text",
                          id: "company_name1",
                          required: ""
                        },
                        domProps: { value: _vm.contactData.company_name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactData,
                              "company_name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "email1" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.business.contact_email")) + "*"
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactData.email,
                            expression: "contactData.email"
                          }
                        ],
                        ref: "email",
                        staticClass: "form-control input-jumbo",
                        attrs: { type: "email", id: "email1", required: "" },
                        domProps: { value: _vm.contactData.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactData,
                              "email",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "tel1" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.business.contact_tel")) + "*"
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactData.tel,
                            expression: "contactData.tel"
                          }
                        ],
                        ref: "tel",
                        staticClass: "form-control input-jumbo",
                        attrs: { type: "tel", id: "tel1", required: "" },
                        domProps: { value: _vm.contactData.tel },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactData,
                              "tel",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button button-large button-block -cyan",
                      attrs: { type: "submit" }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t(_vm.isSending)) + "\n            "
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("section", [_c("section-partner"), _vm._v(" "), _vm._m(9)], 1),
    _vm._v(" "),
    _vm._m(10)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid w-100",
          attrs: { src: "/static/img/beneatForBussiness/a1.png", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid w-100",
          attrs: { src: "/static/img/beneatForBussiness/a2.png", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid w-100",
          attrs: { src: "/static/img/beneatForBussiness/a3.png", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid w-100",
          attrs: { src: "/static/img/beneatForBussiness/a4.png", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-6 text-center" }, [
      _c("a", { attrs: { href: "https://line.me/R/ti/p/%40hnk7011n" } }, [
        _c("img", {
          staticClass: "img-fluid w-100",
          attrs: {
            src: "/static/img/beneatForBussiness/contact-line.png",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("h2", { staticStyle: { "margin-top": "50px" } }, [
        _vm._v("หรือ โทร 02-113-1138")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid w-100",
          attrs: { src: "/static/img/beneatForBussiness/a5.png", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid w-100",
          attrs: { src: "/static/img/beneatForBussiness/a6.png", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid w-100",
          attrs: { src: "/static/img/beneatForBussiness/a7.png", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-6 text-center" }, [
      _c("a", { attrs: { href: "https://line.me/R/ti/p/%40hnk7011n" } }, [
        _c("img", {
          staticClass: "img-fluid w-100",
          attrs: {
            src: "/static/img/beneatForBussiness/contact-line.png",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("h2", { staticStyle: { "margin-top": "50px" } }, [
        _vm._v("หรือ โทร 02-113-1138")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6 pr-3 pl-3" }, [
        _c(
          "div",
          { staticClass: "embed-responsive embed-responsive-16by9 mt-4" },
          [
            _c("iframe", {
              attrs: {
                width: "560",
                height: "315",
                src: "https://www.youtube.com/embed/RTbcjC9Udzg",
                frameborder: "0",
                allow: "autoplay; encrypted-media",
                allowfullscreen: ""
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6 pr-3 pl-3" }, [
        _c(
          "div",
          { staticClass: "embed-responsive embed-responsive-16by9 mt-4" },
          [
            _c("iframe", {
              attrs: {
                width: "560",
                height: "315",
                src: "https://www.youtube.com/embed/xCGWH7JU83M",
                frameborder: "0",
                allow: "autoplay; encrypted-media",
                allowfullscreen: ""
              }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "row",
        staticStyle: { "margin-top": "100px", "margin-bottom": "100px" }
      },
      [
        _c("div", { staticClass: "col-12 text-center" }, [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v("Download Application")
          ]),
          _vm._v(" "),
          _c("hr", { staticStyle: { "border-top": "2px solid #24d4e7" } }),
          _vm._v(" "),
          _c("div", { staticClass: "plat-form-icon" }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://itunes.apple.com/th/app/beneat/id1203611695?mt=8"
                }
              },
              [
                _c("img", {
                  attrs: { src: "/static/img/btn-app-store.svg", alt: "" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://play.google.com/store/apps/details?id=com.beneat.app"
                }
              },
              [
                _c("img", {
                  attrs: { src: "/static/img/btn-play-store.svg", alt: "" }
                })
              ]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a045ee4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a045ee4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/BeneatForBussiness.vue
// module id = 1632
// module chunks = 0